var _circle, _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseLength(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "url(#paint0_linear_81_7232)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 37C30.299 37 35 32.299 35 26.5C35 20.701 30.299 16 24.5 16C18.701 16 14 20.701 14 26.5C14 32.299 18.701 37 24.5 37Z",
    fill: "#F9B42A",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_7232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 17,
    width: 21,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5295 36C30.0849 36 34.5883 31.7467 34.5883 26.5C34.5883 21.2533 30.0849 17 24.5295 17C18.9742 17 14.4707 21.2533 14.4707 26.5C14.4707 31.7467 18.9742 36 24.5295 36Z",
    fill: "#F9B42A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_7232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9707 36C29.8004 36 34.5263 31.7467 34.5263 26.5C34.5263 21.2533 29.8004 17 23.9707 17V36Z",
    fill: "#FFA64D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 18L32.1665 16.5833L30.9999 18Z",
    fill: "#F9B42A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3332 11.3333H21.6665M23.9998 11.3333V15.9999M30.9999 18L32.1665 16.5833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26.5V23V26.5ZM24.5 26.5H21H24.5Z",
    fill: "#F9B42A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26.5H21M24.5 26.5V23V26.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_7232",
    x1: 2,
    y1: 2,
    x2: 54.1365,
    y2: 16.2675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2380AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B978F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseLength);
export default __webpack_public_path__ + "static/media/course-length.c0afd82f.svg";
export { ForwardRef as ReactComponent };